import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { itemShareIntent } from '../item/itemsActions'

export default class ShareButtonTwitter extends PureComponent {
  render() {
    const { link, itemTitle } = this.props
    const href = 'https://twitter.com/intent/tweet?text=' +  encodeURIComponent(itemTitle) + '&url=' + link
    const title = 'Jaa uutinen Twitterissä'

    // https://fontawesome.com/v6/icons/x-twitter?f=brands&s=solid
    return (
      <a
        className='share-button share-button--twitter'
        target='_blank'
        rel='noopener noreferrer'
        href={ href }
        title={ title }
        onClick={ this.handleClick }
      >
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='15' height='15'>
          <path d='M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z' />
        </svg>
      </a>
    )
  }

  handleClick = () => {
    const { itemId, dispatch } = this.props
    dispatch(itemShareIntent(itemId, 'twitter'))
  }
}

ShareButtonTwitter.propTypes = exact({
  itemTitle: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  itemId: PropTypes.string.isRequired,
})
